import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=7855bdb6&scoped=true"
import script from "./ViewTicket.vue?vue&type=script&lang=js"
export * from "./ViewTicket.vue?vue&type=script&lang=js"
import style0 from "./ViewTicket.vue?vue&type=style&index=0&id=7855bdb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855bdb6",
  null
  
)

export default component.exports